/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/
import { getTypes, getModule, getStore } from '../utils/storeUtil'
import { getter, mutation, action } from '../utils/vuexUtil'
import storage from 'src/unit/storage'

export const storeName = 'common'

/** state **/
let state = {
    sidebar: {
        // opened: !+storage.get('sidebarStatus')
        opened: false
    },
    pageParams: null,
    messageInfo: {
        trigger: false
    }
}

/** getters **/
let getters = getter(state, {
    sidebar: state => state.sidebar,
    pageParams: state => state.pageParams,
    messageInfo: state => state.messageInfo
})

/** mutations **/
let mutations = mutation(state, {
    TOGGLE_SIDEBAR(state) {
        state.sidebar.opened = !state.sidebar.opened
    },
    SET_PAGE_PARAMS(state, params) {
        if (params) {
            storage.set('pageParams', params)
            state.pageParams = params
        } else {
            storage.set('pageParams', '')
            state.pageParams = null
        }
    },
    SET_MESSAGE_INFO(state, data) {
        if (data) {
            state.messageInfo = data
        }
    }
})

/** actions **/
let actions = action(state, {
    // sidebar展开状态
    async toggleSideBar({ commit }, value) {
        commit('TOGGLE_SIDEBAR')
    },
    async setPageParams({ commit }, params) {
        commit('SET_PAGE_PARAMS', params)
    },
    async setMessageInfo({ commit }, value) {
        commit('SET_MESSAGE_INFO', value)
    }
})

/** module store **/
let store = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

/** exports **/
export let types = getTypes(store)
export let module = getModule(storeName)
export let Store = getStore(module, types)

export default store



// WEBPACK FOOTER //
// ./src/store/modules/common.js